module.exports = __webpack_public_path__ + "static/media/Thumbs.9ff1808b.db";